import styled from 'styled-components';

const LoginWrapper = styled.div`
.forgot-password {
  text-align:right;
  font-size: 12px;
}
`;

export default LoginWrapper;
